function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 1
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  begin: "0s",
  dur: "1.8s",
  values: "1; 20",
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: "0.165, 0.84, 0.44, 1",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "stroke-opacity",
  begin: "0s",
  dur: "1.8s",
  values: "1; 0",
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: "0.3, 0.61, 0.355, 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 1
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  begin: "-0.9s",
  dur: "1.8s",
  values: "1; 20",
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: "0.165, 0.84, 0.44, 1",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "stroke-opacity",
  begin: "-0.9s",
  dur: "1.8s",
  values: "1; 0",
  calcMode: "spline",
  keyTimes: "0; 1",
  keySplines: "0.3, 0.61, 0.355, 1",
  repeatCount: "indefinite"
})));

var SvgPuff = function SvgPuff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 44 44",
    stroke: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPuff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/puff.804237fd.svg";
export { ForwardRef as ReactComponent };